/* andino-tecnico.js — frente técnico, 1-oct-2026 (lo carga snippets/andino-tecnico.liquid)
 * 1. Los botones de mitad de página («COMPRAR EL GOTERO», «LO QUIERO») apuntaban a #ProductInfo, que no existe.
 *    Cualquier enlace a #ProductInfo / #elegi-tu-pack / #packs lleva a los packs de Kaching, centrados en pantalla
 *    (o al formulario de compra si Kaching no cargó). Funciona igual si el frente landing cambia los href.
 * 2. Botón del carrito «Pasate al combo» (data-andino-swap, lo dibuja snippets/andino-envio-combo.liquid):
 *    POST /cart/update.js reemplazando el gotero suelto por el combo y redibuja el cajón.
 * 3. Marca la intención de compra (window.andinoIntencion) para que el pop-up de ANDINO10 no interrumpa al que ya compra.
 */
(function () {
  'use strict';

  var HREFS = ['#productinfo', '#elegi-tu-pack', '#packs', '#comprar'];

  function esCtaPacks(a) {
    var h = (a.getAttribute('href') || '').trim().toLowerCase();
    if (!h || h.charAt(0) !== '#') return false;
    return HREFS.indexOf(h) !== -1;   // exacto: no toca el enlace de accesibilidad #ProductInfo-template--…
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 40 && r.width > 0;
  }

  function destinoPacks() {
    var k = document.querySelector('kaching-bundles-block .kaching-bundles__block--loaded') ||
            document.querySelector('kaching-bundles-block') ||
            document.querySelector('kaching-bundle');
    if (visible(k)) return k;
    var w = document.getElementById('elegi-tu-pack');
    if (visible(w)) return w;
    var f = document.querySelector('product-info form[action*="/cart/add"]') ||
            document.querySelector('form[action*="/cart/add"]');
    if (f) {
      var bloque = f.closest('.product-form, product-form') || f;
      if (visible(bloque)) return bloque;
      var btn = f.querySelector('[type="submit"]');
      if (visible(btn)) return btn;
    }
    return document.querySelector('product-info') || null;
  }

  function irAPacks() {
    var el = destinoPacks();
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var k = el.closest ? (el.closest('kaching-bundles-block') || el.querySelector && el.querySelector('.kaching-bundles')) : null;
    if (k) {
      k.classList.remove('andino-pulso');
      setTimeout(function () { k.classList.add('andino-pulso'); }, 450);
      setTimeout(function () { k.classList.remove('andino-pulso'); }, 3200);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && esCtaPacks(a)) {
      if (irAPacks()) {
        e.preventDefault();
        window.andinoIntencion = true;
      }
      return;
    }
    // Intención de compra: tocar un pack o el botón de agregar
    if (e.target.closest && e.target.closest('kaching-bundles-block, form[action*="/cart/add"], cart-drawer, #cart-icon-bubble')) {
      window.andinoIntencion = true;
    }
  }, true);

  // Si alguien entra con #ProductInfo / #elegi-tu-pack en la URL
  if (HREFS.indexOf((location.hash || '').toLowerCase()) !== -1) {
    window.addEventListener('load', function () { setTimeout(irAPacks, 800); });
  }

  /* 2. Pasate al combo */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-andino-swap]');
    if (!btn) return;
    e.preventDefault();
    var updates;
    try { updates = JSON.parse(btn.getAttribute('data-andino-swap')); } catch (err) { return; }
    var textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Cambiando…';
    window.andinoIntencion = true;
    var enCajon = !!btn.closest('cart-drawer');
    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'error');
        var drawer = document.querySelector('cart-drawer');
        if (enCajon && drawer && typeof drawer.renderContents === 'function' && res.j.sections && res.j.sections['cart-drawer']) {
          drawer.renderContents({ id: null, sections: res.j.sections });
        } else {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('andino:combo', { detail: { updates: updates } }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = textoOriginal;
        window.location.href = '/cart';
      });
  });
})();
